import { Component, Input, OnInit } from '@angular/core';
import { UserSmall } from '@interfaces/user';

@Component({
  selector: 'app-call-reserve',
  templateUrl: './call-reserve.component.html',
  styleUrls: ['./call-reserve.component.scss'],
})
export class CallReserveComponent implements OnInit {
  @Input() callUser?: UserSmall;
  @Input() hasActiveService = false;

  isReserveExpanded = false;
  selectedDate: string = '';
  minDate: string = '';
  timeInput: string = '';
  displayTime: string = '__:__';

  constructor() { }

  ngOnInit() {
    // Inicializar fecha actual
    const today = new Date();
    this.selectedDate = today.toISOString().split('T')[0];
    this.minDate = today.toISOString().split('T')[0];
  }

  onToggleReserve(event: any) {
    this.isReserveExpanded = event.detail.checked;
  }

  onDateChange(event: any) {
    this.selectedDate = event.detail.value;
  }

  onTimeInput(event: any) {
    const input = event.target.value;

    // Solo permitir números
    const numbers = input.replace(/\D/g, '');

    // Limitar a 4 dígitos máximo
    const limitedNumbers = numbers.slice(0, 4);

    // Solo validar cuando tengamos suficientes dígitos para determinar la validez final
    if (limitedNumbers.length === 4) {
      const hours = parseInt(limitedNumbers.slice(0, 2));
      const minutes = parseInt(limitedNumbers.slice(2, 4));

      // Validar rango completo solo cuando tenemos 4 dígitos
      if (hours > 23 || minutes > 59) {
        // Si es inválido con 4 dígitos, no permitir esta entrada
        return;
      }
    }

    // Actualizar el input interno
    this.timeInput = limitedNumbers;

    // Formatear para mostrar
    this.formatTimeDisplay(limitedNumbers);
  }

  formatTimeDisplay(numbers: string) {
    if (numbers.length === 0) {
      this.displayTime = '__:__';
      return;
    }

    // Crear máscara base
    let display = '____';

    // Rellenar de derecha a izquierda
    for (let i = 0; i < numbers.length; i++) {
      display = display.slice(0, 4 - numbers.length + i) + numbers[i] + display.slice(4 - numbers.length + i + 1);
    }

    // Formatear como HH:MM
    this.displayTime = `${display.slice(0, 2)}:${display.slice(2, 4)}`;
  }

  getFormattedTime(): string | null {
    if (this.timeInput.length !== 4) {
      return null;
    }

    const hours = parseInt(this.timeInput.slice(0, 2));
    const minutes = parseInt(this.timeInput.slice(2, 4));

    // Validar horas (0-23) y minutos (0-59)
    if (hours > 23 || minutes > 59) {
      return null;
    }

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  isTimeValid(): boolean {
    return this.getFormattedTime() !== null;
  }

  // Getter para mantener compatibilidad con código existente
  get selectedTime(): { hour: number, minute: number, period: 'AM' | 'PM' } {
    const formatted = this.getFormattedTime();
    if (!formatted) {
      return { hour: 10, minute: 0, period: 'AM' };
    }

    const [hours, minutes] = formatted.split(':').map(n => parseInt(n));

    // Convertir formato 24h a 12h con AM/PM
    let displayHour = hours;
    let period: 'AM' | 'PM' = 'AM';

    if (hours === 0) {
      displayHour = 12;
      period = 'AM';
    } else if (hours === 12) {
      displayHour = 12;
      period = 'PM';
    } else if (hours > 12) {
      displayHour = hours - 12;
      period = 'PM';
    }

    return { hour: displayHour, minute: minutes, period };
  }

  // Setter para mantener compatibilidad con código existente
  set selectedTime(value: { hour: number, minute: number, period: 'AM' | 'PM' }) {
    let hours = value.hour;

    // Convertir formato 12h a 24h
    if (value.period === 'AM' && hours === 12) {
      hours = 0;
    } else if (value.period === 'PM' && hours !== 12) {
      hours += 12;
    }

    // Formatear como string de 4 dígitos
    const timeString = hours.toString().padStart(2, '0') + value.minute.toString().padStart(2, '0');
    this.timeInput = timeString;
    this.formatTimeDisplay(timeString);
  }

}
